import { useTranslation } from "react-i18next";
import SolarIcon from 'components/icons/SolarIcon';
import vconst from "utils/helpers/structs/vconst"

const ObjectStatusIcon = ({status, objectFinished = null}) => {
    const { t } = useTranslation(['Objects']);
    const icons = {
        [vconst.objectInWork]       : { name: 'play-circle', className: 'fs-18 text-success' },
        [vconst.objectFinishedTeam] : { name: 'check-circle', className: 'fs-18 text-success' },
        [vconst.objectFinished]     : { name: 'check-circle-fill', className: 'fs-18 text-success' },
        [vconst.objectReject]       : { name: 'x-circle-fill', className: 'fs-18 text-danger' },
        [vconst.objectPanding]      : { name: 'pause-circle', className: 'fs-14 fs-18 text-warning' },
    }
    const icon = icons[status];

    return (
         <SolarIcon name={icon?.name || 'circle'}
            className={icon?.className}
            title={`${t(`status.${status}`)}${objectFinished ? `: ${objectFinished}` : ''}`} />
         )

}

export default ObjectStatusIcon;
